"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var styled_components_1 = __importDefault(require("styled-components"));
var ScrollToTopButton = styled_components_1.default.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  position: fixed;\n  right: 15px;\n  bottom: 15px;\n  background: #323232;\n  border: 1px solid #323232;\n  height: 40px;\n  width: 40px;\n  text-align: center;\n  cursor: pointer;\n  &:hover {\n    background: ", ";\n  }\n  i {\n    color: #fff;\n    line-height: 40px;\n  }\n"], ["\n  position: fixed;\n  right: 15px;\n  bottom: 15px;\n  background: #323232;\n  border: 1px solid #323232;\n  height: 40px;\n  width: 40px;\n  text-align: center;\n  cursor: pointer;\n  &:hover {\n    background: ", ";\n  }\n  i {\n    color: #fff;\n    line-height: 40px;\n  }\n"])), function (props) { return props.theme.primary; });
var ScrollToTop = function (_a) {
    var _b = _a.dark, dark = _b === void 0 ? false : _b, _c = _a.pixelFromEnd, pixelFromEnd = _c === void 0 ? 300 : _c;
    var _d = react_1.useState(false), visible = _d[0], setVisible = _d[1];
    react_1.useLayoutEffect(function () {
        var handleScroll = function () {
            setVisible(window.innerHeight + window.pageYOffset >=
                document.body.offsetHeight - pixelFromEnd);
        };
        window.addEventListener('scroll', handleScroll);
        return function () {
            window.removeEventListener('scroll', handleScroll);
        };
    }, [pixelFromEnd]);
    return (react_1.default.createElement(react_1.default.Fragment, null, visible && (react_1.default.createElement(ScrollToTopButton, { dark: dark, onClick: function () {
            window.scrollTo({
                top: 0,
                behavior: 'smooth'
            });
        } },
        react_1.default.createElement("i", { className: "material-icons" }, "expand_less")))));
};
exports.default = ScrollToTop;
var templateObject_1;
//# sourceMappingURL=ScrollToTop.js.map